import $ from 'jquery';
import 'slick-carousel';
import isElement from '../../scripts/util/isElement';

const selectors = {
	slider: '.js--sites-slider'
};

const slickSettings = {
	prevArrow: '<div class= "sites-slider__arrow mod--type-left"><span><svg width="62" height="18" viewBox="0 0 62 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M61 9H1.98364" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M7.88525 16L1 9L7.88525 2" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></svg></span></div>',
	nextArrow: '<div class= "sites-slider__arrow mod--type-right"><span><svg width="62" height="18" viewBox="0 0 62 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M61 9H1.98364" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/><path d="M7.88525 16L1 9L7.88525 2" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></svg></span></div>',
	infinite: true,
	dots: false,
	slidesToShow: 2,
	slidesToScroll: 2,
	speed: 750,
	fade: false,
	adaptiveHeight: false,
	waitForAnimate: false,
	responsive: [{
		breakpoint: 768,
		settings: {
			centerMode: true,
			centerPadding: '20px',
			slidesToShow: 1,
			arrows: false,
			dots: false,
			fade: false,
			touchThreshold: 5,
			swipeToSlide: true,
			waitForAnimate: true,
			cssEase: 'ease',
			speed: 300,
			edgeFriction: 0.5,
			adaptiveHeight: false
		}
	}]
};

const sitesSlickCarousel = settings => {
	const slider = $(selectors.slider);
	slider.slick(settings);

	if (slider.hasClass('slick-initialized')) {
		slider.removeClass('is--hidden');
	}

	slider.on('beforeChange', function () {
		if ($(window).width() > 767) {
			$(selectors.slider).addClass('is--disabled');
		}
	});

	slider.on('afterChange', function () {
		setTimeout(function () {
			$(selectors.slider).removeClass('is--disabled');
		}, 200);
	});

	slider.on('touchstart', function () {
		let lastX;

		$(this).one('touchend', function () {
			$(this).off('touchmove');
			slider.removeClass('is--drag-left');
			slider.removeClass('is--drag-right');
		}).on('touchmove', function (e) {
			let currentX;
			currentX = e.originalEvent.touches ? e.originalEvent.touches[0].clientX : e.originalEvent.clientX;

			if (currentX > lastX) {
				slider.removeClass('is--drag-left');
				slider.addClass('is--drag-right');
			} else if (currentX < lastX) {
				slider.removeClass('is--drag-right');
				slider.addClass('is--drag-left');
			}
			lastX = currentX;
		});
	});
};

const render = () => {
	if (isElement(selectors.slider)) {
		sitesSlickCarousel(slickSettings);
	}
};

export default render;
